'use strict';

import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import entryFactory from "bpmn-js-properties-panel/lib/factory/EntryFactory";
import { getExtensionElement, modifyExtensionElement } from "../../../../../util/camundaPropertiesPanelUtils";

export default function(group, element, bpmnFactory, translate, modeling) {

  const bo = getBusinessObject(element);

  if (!bo) {
    return;
  }

  const setIsExecutavel = function(elementParam, value){
    const bo = getBusinessObject(elementParam);
    const isExecutavelPortalExterno = value && value.isExecutavelPortalExterno;
    modifyExtensionElement("isExecutavelPortalExterno", isExecutavelPortalExterno, elementParam, bo, bpmnFactory, modeling);
  }

  const getIsExecutavel = function(elementParam){
    const bo = getBusinessObject(elementParam);
    const isExecutavelPortalExternoValue = getExtensionElement("isExecutavelPortalExterno", bo);
    return {
      "isExecutavelPortalExterno": isExecutavelPortalExternoValue
    }
  }

  if (is(element, 'bpmn:Process')) {

    const executableEntry = entryFactory.checkbox(translate, {
      id: 'process-is-executable-portal-externo',
      label: translate('External Portal'),
      modelProperty: 'isExecutavelPortalExterno'
    });

    executableEntry.set = (el, value) => setIsExecutavel(element, value);
    executableEntry.get = (el) => getIsExecutavel(element);

    group.entries.push(executableEntry);
  }

  // in participants we have to change the default behavior of set and get
  if(is(element, 'bpmn:Participant') && bo.get('processRef')){
    const processRef = getBusinessObject(element).processRef;

    const participantExecutableEntry = entryFactory.checkbox(translate, {
        id: 'participant-is-executable-portal-externo',
        label: translate('External Portal'),
        modelProperty: 'isExecutavelPortalExterno'
    });

    participantExecutableEntry.set = (el, value) => setIsExecutavel(processRef, value);
    participantExecutableEntry.get = (el) => getIsExecutavel(processRef);

    group.entries.push(participantExecutableEntry);
  }

};
